import Swiper from "swiper/bundle";

const RecommendedSlider = () => {
  const recommendedSlider = document.querySelector('.recommended__slider');
  
  if (recommendedSlider) {
    const recommendedCarousel = new Swiper(recommendedSlider, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 16,
      loop: true,
      pagination: {
        el: ".recommended__slider-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1366: {
          slidesPerView: 4,
        },
      },
    });
  }
}

export default RecommendedSlider